module.exports = __webpack_public_path__ + "img/p_21.ccd01492.png";